import {inheritPrototype, isDef, getObjMaxValue, getObjMinValue} from '../util/util'

import echarts from 'echarts'
import Base from './base'
import constant from '../util/contant'

const defaultNum = constant.defaultNum


// 折线图的配置
var LineShare = function (dataList, type) {
    Base.call(this)
    this.type = type
    if (dataList) {
        this.xList = isDef(dataList.xList) ? dataList.xList : []
        this.yList = isDef(dataList.yList) ? dataList.yList : []
        this.optionSet = isDef(dataList.optionSet) ? dataList.optionSet : {}
    } else {
        this.xList = []
        this.yList = []
        this.optionSet = {}
    }
    this.init()
}
inheritPrototype(LineShare, Base)
LineShare.prototype.init = function () {
    this.option.toolbox = this.getToolbox()
    this.option.grid = this.getGrid()
    this.option.tooltip = this.getTooltip()
    let xaxis = this.getXAxis()
    // xaxis[0].data = this.xList
    let x = []
    for (let item of this.xList) {
        if (isDef(item) && item.indexOf('_') > -1) {
            x.push(item.split('_', -1)[0])
        } else {
            x.push(item)
        }
    }
    xaxis[0].data = x;
    this.option.xAxis = xaxis;
    let axiaArr = []
    this.option.series = this.getSeries(axiaArr)
    this.option.yAxis = this.getYAxis(axiaArr)
    this.option.legend = this.getLegend(this.option.series)
    let isShowDataZoom = isDef(this.optionSet.isShowDataZoom) ? this.optionSet.isShowDataZoom : false
    if (isShowDataZoom && this.xList.length > defaultNum) {
        this.option.dataZoom = this.getDataZoom()
    }
}

// LineShare.prototype.getTooltip = function () {
//   let axisPointerType=isDef(this.optionSet.axisPointerType)?this.optionSet.axisPointerType:'line'
//   return {
//     trigger: 'axis',
//     formatter: '{b}<br/>{a0}: {c0}<br />{a1}: {c1}',
//     axisPointer: {
//       type: axisPointerType
//     }
//   }
// }
LineShare.prototype.getSeries = function (axiaArr) {
    let max = 100
    let min = 0
    let axisArrMaxArr =[];
    let axisArrMinArr =[];
    let itemLineStyleShadow = this.optionSet.isShowitemLineStyleShadow
    let series = []
    let isShowLabel = isDef(this.optionSet.isShowLabel) ? this.optionSet.isShowLabel : false
    if (this.yList) {
        for (let item of this.yList) {
            axisArrMinArr.push(getObjMinValue(item.data));
            axisArrMaxArr.push(getObjMaxValue(item.data));
            let serie = {
                type: 'line',
                //smooth: isDef(item.isSmooth) ? this.optionSet.isSmooth : true,
                name: item.name,
                data: item.data,               
                label: {
                    normal: {
                        show: isShowLabel,
                        position: isDef(item.labelPosition) ? item.labelPosition : 'top',
                        align: isDef(item.labelPositionAlign) ? item.labelPositionAlign : 'top',
                    }
                },
                lineStyle: {
                    normal: {
                        color: isDef(item.color) && item.color.length > 0 ? item.color[0] : '',
                        width: isDef(this.optionSet.lineWidth) ? this.optionSet.lineWidth : '',
                        type: isDef(item.lineType) ? item.lineType : 'solid',//'dashed'
                    }
                },
                itemStyle: {
                    normal: {
                        color: isDef(item.color) && item.color.length > 0 ? item.color[0] : '', // 折点颜色
                        lineStyle: {},
                    }
                }
            }
            let lineStyleShadow = {}
            if (isDef(itemLineStyleShadow) && itemLineStyleShadow) {
                lineStyleShadow = {
                    shadowColor: 'rgba(0, 0, 0, 0.2)',
                    shadowBlur: 8,
                    width: isDef(this.optionSet.lineWidth) ? this.optionSet.lineWidth : 3,
                    shadowOffsetY: 8,
                    color: isDef(item.color) && item.color.length > 0 ? item.color[0] : ''
                }
            } else {
                lineStyleShadow = {
                    color: isDef(item.color) && item.color.length > 0 ? item.color[0] : '',
                    width: isDef(this.optionSet.lineWidth) ? this.optionSet.lineWidth : 3
                }
            }
            // 折线样式设置
            serie.itemStyle.normal.lineStyle = lineStyleShadow
            // 折线区域样式设置
            if (isDef(item.areacolor) && item.areacolor.length >= 2) {
                serie.areaStyle = {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: item.areacolor[0]
                        }, {
                            offset: 1,
                            color: item.areacolor[1]
                        }])
                    }
                }
            }
            series.push(serie)
        }
        max = getObjMaxValue(axisArrMaxArr)
        min = getObjMinValue(axisArrMinArr)
        axiaArr[0] = min
        axiaArr[1] = max
        return series
    }
}

export default LineShare
